'use strict'

class BroadcastOverviewCtrl {

    constructor ($scope, $rootScope, $http, $state, Broadcast, $mdDialog, $mdToast, paginationService, $transitions) {

        // Dependencies
        this.$http = $http
        this.$state = $state
        this.$mdDialog = $mdDialog
        this.$mdToast = $mdToast
        this.paginationService = paginationService
        this._Broadcast = Broadcast
        this.filters = {
            program: null,
            group: null,
            start: null,
            stop: null,
            planned: null,
        }
        this.groups = []

        // Paginator
        this.pagination = {
            current: 1
        }

        // Watchers
        $rootScope.checkActive = (broadcast) => {
            return broadcast.id === $state.params.id
        }

        let unregister = $transitions.onSuccess({}, (transition) => {
            const toState = transition.to()
            if (toState.name === 'broadcast') {
                this.fetch()
            }
        })

        $scope.$on('broadcasts_refetch', () => this.fetch())

        $scope.$on('$destroy', () => {
            unregister()
        })

        // Fetch overview items
        this.fetch(1)
        this.getPrograms()
        //this.getGroups()
    }

    fetch (pageNumber = null) {
        if (pageNumber != null) {
            this.pagination.current = pageNumber
        }

        this.$http.get('/broadcasts', {
            params: {
                page: this.pagination.current,
                program: this.filters.program || null,
                group: this.filters.group || null,
                start: this.parseDate(this.filters.start) || null,
                stop: this.parseDate(this.filters.stop) || null,
                planned: this.filters.planned,
            },
        })
            .then((response) => {
                this.broadcasts = response.data.data
                this.totalResults = response.data.total
                this.resultPerPage = response.data.per_page
            })
    }

    getPrograms () {
        this.$http.get('/programs/all')
            .then((response) => {
                this.programs = response.data
            })

    }

    getGroups () {
        this.$http.get('/groups/all')
            .then(response => {
                this.groups = response.data
            })
    }

    parseDate (date) {
        if (!(date instanceof Date) || isNaN(date.getTime())) return ''
        return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-')
    }

    goToEpg (broadcast) {
        this.$state.go('epg.update', {
            date: moment(broadcast.start).tz(window.CONFIG.timezone).format('YYYY-MM-DD'),
            broadcastId: broadcast.id,
        })
    }

    goToRundown (broadcast) {
        this.$state.go('rundown', {
            program: broadcast.program_id,
            broadcast: broadcast.id,
        })
    }

    fetchGroupTitle (broadcast) {
        if (!broadcast.group_id) {
            return null
        } else {
            for (let i = 0; i < this.groups.length; i++) {
                if (this.groups[i].id === broadcast.group_id) {
                    return this.groups[i].title
                }
            }
        }
    }

    destroy (id, name, ev) {

        ev.stopPropagation()

        this.$mdDialog.show({

            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true
        }).then(() => {

            this._Broadcast.delete({ id: id }, () => {
                this.fetch(this.pagination.current)
            })

            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.delete?object=Broadcast&title=' + name,
                hideDelay: 3000,
                position: ('top right')
            })

            this.$state.go('broadcast')
        })
    }
}

BroadcastOverviewCtrl.$inject = ['$scope', '$rootScope', '$http', '$state', 'Broadcast', '$mdDialog', '$mdToast', 'paginationService', '$transitions']

module.exports = BroadcastOverviewCtrl
